"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es6.function.name");
var _GiftCardTablePane = _interopRequireDefault(require("./GiftCardTablePane.vue"));
var _GiftCardConfigPane = _interopRequireDefault(require("./GiftCardConfigPane.vue"));
var _GiftCardAssignTaskConfigPane = _interopRequireDefault(require("./GiftCardAssignTaskConfigPane.vue"));
var _GiftCardAssignTaskTablePane = _interopRequireDefault(require("./GiftCardAssignTaskTablePane.vue"));
var _GiftCardListPane = _interopRequireDefault(require("./GiftCardListPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GiftCard',
  components: {
    GiftCardTablePane: _GiftCardTablePane.default,
    GiftCardAssignTaskTablePane: _GiftCardAssignTaskTablePane.default,
    GiftCardAssignTaskConfigPane: _GiftCardAssignTaskConfigPane.default,
    GiftCardConfigPane: _GiftCardConfigPane.default,
    GiftCardListPane: _GiftCardListPane.default
  },
  data: function data() {
    return {
      activeName: 'gift_card_table',
      currGiftCardFnId: null,
      currGiftCardListFnId: null,
      imgAccessDomain: process.env.VUE_APP_COMMENT_IMAGE_URL
    };
  },
  created: function created() {},
  methods: {
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
      if (tab.name === 'gift_card_table') {
        this.currGiftCardFnId = null;
      }
    },
    handleToGiftCardConfig: function handleToGiftCardConfig(fnId) {
      // 礼品卡配置
      this.currGiftCardFnId = fnId;
      this.activeName = 'gift_card_config';
    },
    handleToGiftCardAssignTask: function handleToGiftCardAssignTask(fnId) {
      // 礼品卡发放列表
      this.currGiftCardFnId = fnId;
      this.activeName = 'gift_card_assign_task_table';
    },
    handleToCardList: function handleToCardList(fnId) {
      // 礼品卡列表
      this.currGiftCardListFnId = fnId;
      this.activeName = 'gift_card_list';
    },
    handleAssignTaskConfig: function handleAssignTaskConfig() {
      // 发放任务配置
      this.activeName = 'gift_card_assign_task_config';
    },
    rebackGiftCardAssignTaskTable: function rebackGiftCardAssignTaskTable() {
      // 返回礼品卡发放列表
      this.activeName = 'gift_card_assign_task_table';
    },
    handleSuccess: function handleSuccess() {
      this.activeName = 'gift_card_table';
      this.currGiftCardFnId = '';
      this.$refs.gift_card_table.search();
    }
  }
};